import { render, staticRenderFns } from "./GeneralCard.vue?vue&type=template&id=6f98e9e4&scoped=true"
import script from "./GeneralCard.vue?vue&type=script&lang=js"
export * from "./GeneralCard.vue?vue&type=script&lang=js"
import style0 from "./GeneralCard.vue?vue&type=style&index=0&id=6f98e9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f98e9e4",
  null
  
)

export default component.exports